import React from 'react';
import ListItems from 'organisms/FooterComponent/AU/Presentation/ListItems';
import Accordian from 'atoms/Accordian/Accordian';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import HEADER_CONSTANT from 'organisms/HeaderComponent/AU/HeaderConstants/HeaderConstant';
import ImageComponent from 'atoms/Image';
/**
 *  List Component
 * @param {*} props - Object
 */

const SupportAccordian = props => {
  const { subCategories, onClickHandler } = props;

  const getItems = list => {
    return list.map((item, ind) => {
      return (
        <ListItems
          key={ind}
          onClickHandler={onClickHandler}
          dataTestId={`listItems-component-${item.name}`}
          className='footer-links'
          {...item}
        >
          <ImageComponent srcFile={item?.icon} alt='location-map' className='find-A-kfc-img' />
          {item.name}
        </ListItems>
      );
    });
  };

  return (
    <div>
      <Accordian
        header={translateWithI18Next(HEADER_CONSTANT.SUPPORT)}
        isDarkMode={false}
        shouldDefaultOpen={true}
        dataTestId='support-accordian'
      >
        <ul className='footer-links'>
          <>{getItems(subCategories)}</>
        </ul>
      </Accordian>
    </div>
  );
};

export default SupportAccordian;
